import { render, staticRenderFns } from "./UsersFormedit.vue?vue&type=template&id=2b4774c2&"
import script from "./UsersFormedit.vue?vue&type=script&lang=js&"
export * from "./UsersFormedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports